/** Enkel, streng nok validering av én e-postadresse (samme regel som edge-funksjonene i _shared/gmail.ts). */
const EMAIL_RE = /^[^\s@<>",;]+@[^\s@<>",;]+\.[^\s@<>",;]+$/;

export function isValidEmail(value: string | null | undefined): boolean {
  return !!value && EMAIL_RE.test(value.trim());
}
